import DefaultTableResize from '@/components/DefaultTableResize';
import { DefaultActions, Search, Separator, Showing, Total, Wrapper } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid, useGrid } from '@Components/Grid';

import ContestsSubscriptionsHeaderButtons from '../../components/ContestsSubscriptionsHeaderButtons';
import { ContestsSubscriptionsProvider, useContestsSubscriptionsStore } from '../../store';

import { ContestsSubscriptionsStateProvider } from './hooks/states';
import useColumns from './useColumns';
import useDefinitions from './useDefinitions';

function ContestsSubscriptionsGrid() {
  const { columns = [], store: { collections: { items = [] } } } = useGrid()

  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions add={null}>
        <ContestsSubscriptionsHeaderButtons />
      </DefaultActions>
    </Wrapper>}
    table={<DefaultTableResize
      columns={columns}
      data={items}
    />}
    filters={null}
  />
}

function ContestsSubscriptionsGridLayout() {
  return <GridProvider store={useContestsSubscriptionsStore()}>
    <ContestsSubscriptionsStateProvider>
      <ContestsSubscriptionsGrid />
    </ContestsSubscriptionsStateProvider>
  </GridProvider>
}

export default function ContestsSubscriptionsLayout() {
  return <ContestsSubscriptionsProvider>
    <ContestsSubscriptionsGridLayout />
  </ContestsSubscriptionsProvider>
}
